import { render, staticRenderFns } from "./CommentPage.vue?vue&type=template&id=0aaa31ae&scoped=true"
import script from "./CommentPage.vue?vue&type=script&lang=js"
export * from "./CommentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaa31ae",
  null
  
)

export default component.exports